import React from 'react';
import { Divider } from 'wix-ui-tpa/cssVars';
import { useSettings } from '@wix/tpa-settings/react';
import { useResizeObserver } from '@react-hookz/web';
import { st, classes } from './Widget.st.css';
import { Header } from './Header/Header';
import { Body } from './Body/Body';
import { useWidgetViewModel } from '../hooks/useWidgetViewModel';
import Dialog from '../../../shared/components/Dialog/Dialog';
import { useEnvironment } from '@wix/yoshi-flow-editor';
import { useDatePicker } from '../hooks/useDatePicker';
import settingsParams from '../settingsParams';

export const Widget: React.FC = () => {
  const { isInitDataLoading, dialogViewModel } = useWidgetViewModel();
  const { setHeaderSize } = useDatePicker();
  const settings = useSettings();
  const { isMobile, isRTL } = useEnvironment();
  const elementRef = React.useRef<HTMLDivElement>(null);
  const isHeaderSticky = settings.get(settingsParams.headerSticky);
  useResizeObserver(elementRef, (entry: ResizeObserverEntry) => {
    if (isHeaderSticky) {
      setHeaderSize({
        width: entry.contentRect.width,
        height: entry.contentRect.height,
      });
    }
  });

  return (
    <div
      className={st(classes.root, { isMobile, isRTL, isHeaderSticky })}
      dir={isRTL ? 'rtl' : 'ltr'}
      data-hook="DailyAgenda-wrapper"
    >
      <div
        className={classes.headerWrapper}
        id="daily-agenda-header-wrapper"
        ref={elementRef}
      >
        <Header />
        <div className={classes.dividerWrapper}>
          <Divider className={classes.divider} />
        </div>
      </div>
      {!isInitDataLoading && <Body />}
      {dialogViewModel && <Dialog viewModel={dialogViewModel} />}
    </div>
  );
};
